import styles from "../styles/ui/AssetDisplay.module.css";
import React from "react";

function AssetDisplay({ asset, style = {}, className = "", isCrypto = false }) {
  return (
    <div className={`${styles.coin} ${className}`} style={style}>
      <div className={styles.coinImage}>
        <img
          src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${asset?.replace("/USDT", "")}.png`}
          alt={asset}
          className={styles.symbolImage}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/placeholders/asset-logo.svg";
          }}
        />
        {isCrypto && (
          <img
            src="https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/USDT.png"
            alt="tether"
            className={styles.tetherImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholders/asset-logo.svg";
            }}
          />
        )}
      </div>
      <div>
        {asset?.replace("/USDT", "")}
        {isCrypto ? <span className={styles.usdtLabel}> / USDT</span> : null}
      </div>
    </div>
  );
}

export default AssetDisplay;
